import styled from 'styled-components'
import { breakpoints } from '../../../constants'
import Browser from '../../../services/Browser'
import {
	BLUE,
	TEXT_PRIMARY,
	WHITE,
	MEDIUMORANGE,
	SILVER,
	BACKGROUNDBLACKFRIDAYHEADER,
	FONTYELLOWBLACKFRIDAYHEADER
} from '../../../styles/colors.style'
import {
	dropShadow,
	roundOrangeButton,
	squareOrangeButton
} from '../../../styles/reusable.style'
import { isMobile } from '../../../helpers'
import { isBlackFriday } from '../../../helpers/isBlackFriday'
const MENU_LINK_PAD = '15px 25px'

/**
 * @param {boolean} isPrivate
 * for private areas
 *
 * @param {boolean} transparent
 * makes the header's background transparent
 */
export const StyledContainerHeader = styled.header`
	${({ isPrivate }) => isPrivate && `align-items: center;`}
	${({ isPrivate }) => isPrivate && `display: flex;`}
	box-sizing: border-box;
	font-size: 1.8rem;
	justify-content: space-between;
	padding: 1.667rem;
	padding-left: 1.4rem;
	position: ${isMobile() ? 'static' : 'fixed'};
	top: 0;
	width: 100vw;
	z-index: 4;
	background-color: ${isBlackFriday ? BACKGROUNDBLACKFRIDAYHEADER : '#fff'};

	${props =>
		(!props.transparent || location.pathname != '/') && isBlackFriday
			? BACKGROUNDBLACKFRIDAYHEADER
			: '#fff'}
	${() =>
		location.pathname == '/' &&
		'box-shadow:	0px 5px 10px -2px rgba(0, 0, 0, 0.3);'} 

	@media (min-width: ${breakpoints.MOBILE}px) {
		padding: 0rem 4.4rem 0 2rem;
		${({ isPrivate }) => isPrivate && `padding: 1rem 4.4rem 0 2.0rem;`}
	}
	@media (min-width: ${breakpoints.MOBILE}px) {
		.mobile-menu {
			display: none;
		}
	}

	.header__logo {
		max-width: 60%;

		@media (min-width: ${breakpoints.MOBILE}px) {
			padding-right: 20px;
		}

		img {
			height: 44px;
		}

		.logotype.not-client {
			@media screen and (min-width: ${breakpoints.MOBILE}px) and (max-width: 1230px) {
				display: none;
			}
		}

		.logomark {
			display: none;

			&.not-client {
				@media screen and (min-width: ${breakpoints.MOBILE}px) and (max-width: 1230px) {
					display: flex;
				}
			}
		}
	}

	.menu {
		@media (min-width: ${breakpoints.MOBILE}px) {
			flex: 1;
			display: flex;
			justify-content: flex-end;

			&.logged-false {
				display: flex;
				flex: 1;
			}
		}

		&__links {
			display: flex;
			flex-direction: column;
			position: absolute;
			${isMobile() ? 'z-index: 99;' : ''}
			left: 0;
			float: right;
			max-height: 0;
			transition: unset;
			overflow: hidden;
			background-color: #fff;

			&.is-open {
				display: flex;
				max-height: 1000px;
				border: 1px solid #dddddd;
				transition: height 1s ease-in;
				width: 100%;

				${dropShadow()};

				@media (min-width: ${breakpoints.MOBILE}px) {
					box-shadow: unset;
					border: unset;
					width: auto;
				}

				@media screen and (max-width: 321px) {
					${() => location.pathname !== '/' && 'margin-top: 97px;'}
				}
			}

			@media (min-width: ${breakpoints.MOBILE}px) {
				flex-direction: row;
				max-height: unset;
				${Browser.isIE() ? `max-height: 100%;` : null} position: relative;
				box-shadow: unset;
				justify-content: space-between;
				align-items: center;
				background-color: transparent;

				&.is-open {
					transition: unset;
				}
			}

			&.logged-in .menu__links-block {
				@media (min-width: ${breakpoints.MOBILE}px) {
					&:nth-child(1) {
						order: 0;
						flex: ${Browser.isInternetExplorer() ? 'none' : '1'};
						justify-content: flex-end;
						width: max-content;
					}

					&:nth-child(2) {
						order: 1;
					}

					&:nth-child(3) {
						order: 3;
					}
				}
			}

			&-block {
				display: flex;
				flex-direction: column;

				@media (min-width: ${breakpoints.MOBILE}px) {
					flex-direction: row;
					align-items: center;
				}

				a {
					color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : BLUE};
					text-transform: uppercase;
					font-weight: 600;
					font-size: 1.8rem;
					text-decoration: none;
					padding: ${MENU_LINK_PAD};

					@media (min-width: ${breakpoints.MOBILE}px) {
						text-transform: none;
						padding: 0;
						color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY};
						padding: 0 15px;
					}

					&:hover {
						text-decoration: underline;
					}
				}

				.name,
				.points {
					display: flex;
					flex-direction: column;
					padding: ${MENU_LINK_PAD};

					@media screen and (min-width: ${breakpoints.MOBILE}px) {
						padding: 0 15px;
					}
				}

				.name {
					${({ isPrivate }) =>
						!isPrivate &&
						`color:  ${
							isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY
						};`}
				}

				.sair {
					@media screen and (min-width: ${breakpoints.MOBILE}px) {
						${({ isPrivate }) => !isPrivate && roundOrangeButton()}
					}
					transition: background-color 0.5s !important;
				}

				.points {
					@media screen and (min-width: ${breakpoints.MOBILE}px) {
						align-items: flex-end;
					}
				}
			}

			.cadastre-se {
				&-btn {
					@media (min-width: ${breakpoints.MOBILE}px) {
						${roundOrangeButton()}
						min-width: 250px;
						margin-top: 5px;
						font-size: 2rem;
						padding: 1.6rem 2.5rem;
					}
				}
				&-div {
					@media (min-width: ${breakpoints.MOBILE}px) {
						text-align: center;
						.ganhe-descontos {
							font-size: 1.6rem;
							font-weight: bold;
							color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY};
						}
					}
					@media (max-width: ${breakpoints.MOBILE}px) {
						padding: 15px 0px;
						.ganhe-descontos {
							display: none;
						}
					}
				}

				&-text {
					display: none;

					@media (min-width: 1314px) {
						display: inline;
						margin-right: 5rem;
					}
				}
			}
		}
	}

	.box-login-mobile {
		&.logged-true {
			background: transparent;
			height: auto;
		}

		background: ${BLUE};
		height: 160px;

		.box-cadastro {
			margin: 5px auto 0;
			border-radius: 5px;
			width: 260px;
			height: 50px;
			background: ${MEDIUMORANGE};

			a {
				display: block;
				padding: 0;
				font: bold 16px/50px 'Source Sans Pro';
				color: ${WHITE};
				text-align: center;
			}
		}

		small {
			display: block;
			color: ${WHITE};
			font: 15px/19px 'Source Sans Pro';
			text-align: center;
			padding-bottom: 5px;
		}
		.entrar {
			text-transform: capitalize;
			color: ${WHITE};
			padding: 0;
			font: bold 20px/25px 'Source Sans Pro';
			text-align: center;
			display: block;
		}
	}

	.links-mobile {
		width: 337px;
		margin: 0 auto;

		span {
			a {
				display: block;
				padding: 0;

				div {
					border-bottom: 1px solid ${SILVER};
					display: flex;
					height: 49px;
					align-items: center;

					svg {
						fill: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : BLUE};
						margin-right: 15px;
					}

					div {
						border: 0;
						color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY};
						font: 600 18px/30px 'Source Sans Pro';
						text-transform: none;
						display: inline-block;
						height: 34px;
					}
				}
			}

			&:first-child {
				svg {
					transform: rotateX(-180deg);
				}
			}

			&:last-child {
				div {
					border: 0;
				}
			}
		}
	}
	.sair {
		&.mobile {
			font-weight: 800;
			padding-top: 0;
			padding-left: 19px;
			color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY};
		}
	}

	.logotipo-planalto-menor {
		margin-bottom: 4px;
	}

	.logotipo-planalto-menor-private {
		margin-bottom: 7px;
	}
`

export const StyledBackToTopBtn = styled.button`
	display: ${props => (props.scrollNum >= 155 ? '' : 'none')};
	height: 40px;
	width: 40px;
	background-color: #fff;
	border-radius: 30px;
	position: fixed;
	font-size: 18px;
	font-weight: bolder;
	top: 15px;
	right: 30px;
	z-index: 4;
	overflow: hidden;
	color: #517abc;
	padding: 0;
`

export const MenuHorizontal = styled.div`
	overflow-y: hidden;
	overflow-x: auto;
	display: flex;
	flex: 3;
	justify-content: space-around;

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		height: 80px;
		overflow: hidden;
	}
	.scrollmenu,
	.scrollCardMenu {
		display: flex;
		margin-top: 10px;
		padding-left: 15px;

		@media (min-width: ${breakpoints.MOBILE}px) {
			margin-top: 10px;
			margin-bottom: 5px;
		}

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			margin-top: 0;
		}
	}

	.scrollmenu-mobile-true {
		padding-left: 0px;
		overflow-x: scroll;
	}

	.scrollmenu-mobile-true::before,
	.scrollmenu-mobile-true::after {
		background-image: linear-gradient(
			to left,
			rgba(255, 255, 255, 0),
			rgba(255, 255, 255, 0.6) 50%,
			#fff
		);
		content: '';
		height: ${isMobile() ? '13%' : '50%'};
		position: absolute;
		top: 65px;
		width: 50px;
		z-index: 1;
	}

	.scrollmenu-mobile-true::after {
		background-image: linear-gradient(
			to right,
			rgba(255, 255, 255, 0),
			rgba(255, 255, 255, 0.6) 50%,
			#fff
		);
		right: 21px;
	}

	.scrollmenu-right::after {
		visibility: hidden;
	}

	.scrollmenu-left::before {
		visibility: hidden;
	}

	.scrollmenu-both::after,
	.scrollmenu-both::before {
		visibility: visible;
	}

	.scrollmenu {
		span {
			&:first-child {
				svg {
					transform: rotateX(-180deg);
				}
			}
		}
	}
	.scrollmenu a,
	.scrollCardMenu a {
		display: flex;
		padding: 4.3% 7%;
		text-align: center;
		text-decoration: none;

		a:first-child {
			padding: 0;
		}

		color: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : TEXT_PRIMARY};
		font-size: 1.8rem;
		font-weight: 600;
		text-decoration: none;
		text-transform: uppercase;

		@media (min-width: ${breakpoints.MOBILE}px) {
			padding: 3px 5px;
			text-transform: none;
		}

		&:hover {
			text-decoration: underline;
		}

		svg {
			fill: ${isBlackFriday ? FONTYELLOWBLACKFRIDAYHEADER : BLUE};
		}

		span {
			align-self: center;
			display: block;
			width: auto;
		}
	}

	.scrollCardMenu span {
		a {
			max-width: 100%;
			width: 137px;
			height: 80px;
			div {
				height: 100%;
				div {
					height: 39px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
		&.fa-close {
			top: 20px;
			right: 5px;
			font-size: 4rem;
		}

		&:nth-child(1),
		&:nth-child(3),
		&:nth-child(4),
		&:last-child {
			div {
				div {
					width: 100%;
					margin: 0 auto;
				}
			}
		}
	}
`

export const StyledLinksBlock = styled.div`
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		.white-when-desktop,
		.entrar.white-when-desktop,
		.blue.bold.name.white-when-desktop {
			display: flex;
		}
		.mt20 {
			margin-top: 20px;
		}
	}
`

export const MenuSubContainer = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	justify-content: space-between;
`

export const LogoContainer = styled.div`
	display: flex;
	flex: 1;
`
